import React from 'react';
import styles from './LightTableContainer.module.scss';

const LightTableContainer = ({ children, title }) => {
  return (
    <div className={styles.container}>
      <h4>{title}</h4>
      {children}
    </div>
  );
};

export default LightTableContainer;
